import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import Login from './pages/Login';
import Layout from './components/layout/Layout';
import Dashboard from './pages/Dashboard';
import MerchantRegistration from './pages/reports/MerchantRegistration';
import MerchantTransaction from './pages/reports/MerchantTransaction';
import MerchantTransactionSummary from './pages/reports/MerchantTransactionSummary';
import AuditLogs from './pages/reports/AuditLogs';
import UserManagement from './pages/admin/UserManagement';
import RoleManagement from './pages/admin/RoleManagement';
// Protected route component
const ProtectedRoute = ({
  children
}) => {
  const {
    user
  } = useAuth();
  if (!user) {
    return <Navigate to="/login" replace data-id="element-0" />;
  }
  return children;
};
export function AppRouter() {
  return <AuthProvider data-id="element-1">
      <BrowserRouter data-id="element-2">
        <Routes data-id="element-3">
          <Route path="/login" element={<Login data-id="element-5" />} data-id="element-4" />
          <Route path="/" element={<ProtectedRoute data-id="element-7">
                <Layout data-id="element-8" />
              </ProtectedRoute>} data-id="element-6">
            <Route index element={<Dashboard data-id="element-10" />} data-id="element-9" />
            <Route path="reports/merchant-registration" element={<MerchantRegistration data-id="element-12" />} data-id="element-11" />
            <Route path="reports/merchant-transaction" element={<MerchantTransaction data-id="element-14" />} data-id="element-13" />
            <Route path="reports/transaction-summary" element={<MerchantTransactionSummary data-id="element-16" />} data-id="element-15" />
            <Route path="reports/audit-logs" element={<AuditLogs data-id="element-18" />} data-id="element-17" />
            <Route path="admin/users" element={<UserManagement data-id="element-20" />} data-id="element-19" />
            <Route path="admin/roles" element={<RoleManagement data-id="element-22" />} data-id="element-21" />
          </Route>
        </Routes>
      </BrowserRouter>
    </AuthProvider>;
}